(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 35035:
/***/ (function(module) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),

/***/ 78581:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(46115);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 87246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CredexUserPromoBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./lib/templateToJsx.js
var templateToJsx = __webpack_require__(60024);
;// CONCATENATED MODULE: ./components/CredexUserPromoBanner/CredexUserPromoBannerDefaultLabel.js


var CredexUserPromoBannerDefaultLabel = function(param) {
    var firstName = param.firstName, credexConfig = param.credexConfig;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            firstName && credexConfig.bannerTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[14px] font-medium",
                children: (0,templateToJsx/* default */.Z)(credexConfig.bannerTitle, {
                    firstName: firstName
                })
            }),
            credexConfig.bannerSubTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[12px]",
                children: credexConfig.bannerSubTitle
            })
        ]
    });
};
/* harmony default export */ var CredexUserPromoBanner_CredexUserPromoBannerDefaultLabel = (CredexUserPromoBannerDefaultLabel);

;// CONCATENATED MODULE: ./components/CredexUserPromoBanner/CredexUserPromoBannerExtraInfoLabel.js


var CredexUserPromoBannerExtraInfoLabel = function(param) {
    var firstName = param.firstName, credexConfig = param.credexConfig, installmentValue = param.installmentValue;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            firstName && credexConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[14px] font-medium",
                children: (0,templateToJsx/* default */.Z)(credexConfig.productPageLabel.userPromo, {
                    firstName: firstName,
                    promoRates: credexConfig.promoRates,
                    promoInterest: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: credexConfig.promoInterest
                    }),
                    installmentValue: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: installmentValue
                    })
                })
            }),
            credexConfig.bannerSubTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[12px]",
                children: credexConfig.bannerSubTitle
            })
        ]
    });
};
/* harmony default export */ var CredexUserPromoBanner_CredexUserPromoBannerExtraInfoLabel = (CredexUserPromoBannerExtraInfoLabel);

;// CONCATENATED MODULE: ./components/CredexUserPromoBanner/index.js





var ref = (0,config["default"])(), settings = ref.publicRuntimeConfig.settings;
var layoutLabel = {
    default: CredexUserPromoBanner_CredexUserPromoBannerDefaultLabel,
    extraInfo: CredexUserPromoBanner_CredexUserPromoBannerExtraInfoLabel
};
// Bussiness has revoked credex modal. Development code is not finished but kept for future reference.
var CredexUserPromoBanner = function(param) {
    var _layout = param.layout, layout = _layout === void 0 ? "default" : _layout, customer = param.customer, installmentValue = param.installmentValue, credexConfig = param.credexConfig;
    var LabelComponent = layoutLabel[layout];
    if (!credexConfig || !customer) {
        return null;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative flex items-center justify-between gap-[8px] overflow-hidden rounded-[4px] text-white bg-cover bg-top bg-no-repeat px-[16px] py-[12px]",
        role: "region",
        "aria-label": "informational-banner",
        style: {
            backgroundImage: "url(".concat(settings.websiteStatics, "/images/credex/credex-customer-promo.png)")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "z-[2]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelComponent, {
                firstName: customer === null || customer === void 0 ? void 0 : customer.first_name,
                credexConfig: credexConfig,
                installmentValue: installmentValue
            })
        })
    }));
};
/* harmony default export */ var components_CredexUserPromoBanner = ((0,es/* connect */.$j)(function(state) {
    return {
        customer: state.user.customer,
        credexConfig: state.credex.data
    };
})(CredexUserPromoBanner));


/***/ }),

/***/ 42009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_1__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, _footprints = _publicRuntimeConfig.footprints, desktopWebAdvertisementScriptUrl = _footprints.desktopWebAdvertisementScriptUrl, mobileWebAdvertisementScriptUrl = _footprints.mobileWebAdvertisementScriptUrl;
var MOBILE_FOOTPRINTS_SCRIPT_ID = "FootprintsWebAdsMobileScript";
var DESKTOP_FOOTPRINTS_SCRIPT_ID = "FootprintsWebAdsDesktopScript";
var FootprintsWebAdsBanner = function(param) {
    var _desktopSize = param.desktopSize, desktopSize = _desktopSize === void 0 ? "728x90" : _desktopSize, _mobileSize = param.mobileSize, mobileSize = _mobileSize === void 0 ? "320x50" : _mobileSize;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), mobileScriptLoaded = ref2[0], setMobileScriptLoaded = ref2[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), desktopScriptLoaded = ref1[0], setDesktopScriptLoaded = ref1[1];
    var loadScript = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        // Add the mobile script
        var mobileScript = document.createElement("script");
        mobileScript.src = mobileWebAdvertisementScriptUrl;
        mobileScript.id = MOBILE_FOOTPRINTS_SCRIPT_ID;
        mobileScript.async = true;
        mobileScript.onload = setMobileScriptLoaded(true);
        // Add the desktop script
        var desktopScript = document.createElement("script");
        desktopScript.src = desktopWebAdvertisementScriptUrl;
        desktopScript.id = DESKTOP_FOOTPRINTS_SCRIPT_ID;
        desktopScript.async = true;
        desktopScript.onload = setDesktopScriptLoaded(true);
        // Append scripts to the document body
        document.body.appendChild(mobileScript);
        document.body.appendChild(desktopScript);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        loadScript();
        return function() {
            // Cleanup scripts on component unmount
            var mobileScript = document.getElementById(MOBILE_FOOTPRINTS_SCRIPT_ID);
            var desktopScript = document.getElementById(DESKTOP_FOOTPRINTS_SCRIPT_ID);
            if (mobileScript) {
                document.body.removeChild(mobileScript);
            }
            if (desktopScript) {
                document.body.removeChild(desktopScript);
            }
        };
    }, []);
    var scriptsLoaded = mobileScriptLoaded || desktopScriptLoaded;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat(scriptsLoaded ? "flex justify-center items-center py-[20px]" : "invisible"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "ffrWebAdvertising".concat(desktopSize, "Desktop")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "ffrWebAdvertising".concat(mobileSize, "Mobile")
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FootprintsWebAdsBanner);


/***/ }),

/***/ 57153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);


var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_1__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var CarouselNavArrow = function(param) {
    var direction = param.direction;
    var rotation = {
        up: "rotate-90",
        down: "-rotate-90",
        left: "",
        right: "-rotate-180"
    }[direction];
    return websiteName === "bricostore" ? // Material Design "chevron_left" (24x24, Apache-2.0) — base points left like the original. Color via fill-current.
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: "transform fill-current ".concat(rotation),
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59Z"
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: "transform ".concat(rotation),
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M22 14L17.334 19.1158C16.8887 19.604 16.8887 20.396 17.334 20.8842L22 26",
            stroke: "black",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CarouselNavArrow);


/***/ }),

/***/ 30866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PromoToasts; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./components/Alert.js + 10 modules
var Alert = __webpack_require__(16479);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./lib/api/helpers.js
var helpers = __webpack_require__(45963);
// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
// EXTERNAL MODULE: ./lib/clientStore.js
var clientStore = __webpack_require__(66208);
;// CONCATENATED MODULE: ./components/PromoToasts/useToasts.js





function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var LOCAL_EXPIRATION_DURATION = 86400000;
// generate localstorage key
var getLocalStoreKey = function(toastId) {
    return "promo-toast-".concat(toastId);
};
var useToasts = function(param) {
    var type = param.type, params = param.params, userInitial = param.userInitial, setPromoToastVisible = param.setPromoToastVisible;
    var ref1 = (0,react.useState)(null), toast = ref1[0], setToast = ref1[1];
    (0,react.useEffect)(function() {
        var initialize = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var ref, res, serverToast, localStoreKey, isLocalDismissed;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _ctx.next = 3;
                            return (0,helpers/* makeApiCall */.Vo)({
                                apiArgs: [
                                    _objectSpread({}, params, {
                                        type: type
                                    })
                                ],
                                apiCall: api/* getPromoNotificationsApi */.H6W,
                                returnResponse: true
                            });
                        case 3:
                            res = _ctx.sent;
                            if ((res === null || res === void 0 ? void 0 : res.ok) && (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref[0])) {
                                serverToast = res.data[0];
                                localStoreKey = getLocalStoreKey(serverToast.id);
                                isLocalDismissed = clientStore/* localClientStore.get */.C.get(localStoreKey);
                                if (!isLocalDismissed) {
                                    setToast(serverToast);
                                }
                            }
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function initialize() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!userInitial && (type === "homepage" || type === "category" && (params === null || params === void 0 ? void 0 : params.categoryId) || type === "product" && (params === null || params === void 0 ? void 0 : params.sku))) {
            initialize();
        }
    }, [
        type,
        params,
        userInitial
    ]);
    (0,react.useEffect)(function() {
        if (toast) {
            setPromoToastVisible(true);
        } else {
            setPromoToastVisible(false);
        }
        return function() {
            return setPromoToastVisible(false);
        };
    }, [
        toast,
        setPromoToastVisible
    ]);
    var setToastRead = function(id) {
        // localstorage key for current toast
        var localStoreKey = getLocalStoreKey(id);
        var expiration = new Date().getTime() + LOCAL_EXPIRATION_DURATION;
        // set the new dismissed toast in localstorage
        clientStore/* localClientStore.set */.C.set(localStoreKey, "dismissed", expiration);
        setToast(null);
    };
    return {
        toast: toast,
        setToastRead: setToastRead
    };
};
/* harmony default export */ var PromoToasts_useToasts = (useToasts);

// EXTERNAL MODULE: ./store/app/actions.js
var actions = __webpack_require__(27173);
;// CONCATENATED MODULE: ./components/PromoToasts/index.js








var ref = (0,config["default"])(), settings = ref.publicRuntimeConfig.settings;
var PromoToasts = function(param) {
    var type = param.type, params = param.params, user = param.user, setPromoToastVisible1 = param.setPromoToastVisible, userDismissedNewsletter = param.userDismissedNewsletter;
    var ref1 = PromoToasts_useToasts({
        type: type,
        params: params,
        userInitial: user.isInitial,
        setPromoToastVisible: setPromoToastVisible1
    }), toast = ref1.toast, setToastRead = ref1.setToastRead;
    if (!toast) {
        return null;
    }
    // TODO add a way to update redux state for the user to dismiss the newsletter popup
    var isCookieConsentPopupVisible = Boolean(!clientStore/* cookieClientStore.get */.u.get("CookieConsent"));
    var isNewsletterPopupVisible = !userDismissedNewsletter;
    var positionClasses = classnames_default()("fixed z-10 right-0 sm:right-[15px] max-w-[420px] min-w-[320px] space-y-2", {
        // all are visible
        "bottom-0 sm:bottom-[100px] xl:bottom-[290px]": isNewsletterPopupVisible && isCookieConsentPopupVisible,
        // only cookies are visible
        "bottom-2 xl:bottom-[200px]": !isNewsletterPopupVisible && isCookieConsentPopupVisible,
        // only newsletter is visible
        "bottom-0 sm:bottom-[100px] xl:bottom-[100px]": isNewsletterPopupVisible && !isCookieConsentPopupVisible,
        // none are visible
        "bottom-0 sm:bottom-[8px]": !isNewsletterPopupVisible && !isCookieConsentPopupVisible
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: positionClasses,
        children: toast && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
            type: "blank",
            hasShadow: true,
            onClose: function() {
                return setToastRead(toast.id);
            },
            showIcon: !!(toast === null || toast === void 0 ? void 0 : toast.image),
            image: {
                src: "".concat(settings.cdn, "/media/label/image").concat(toast === null || toast === void 0 ? void 0 : toast.image),
                alt: toast.title
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-sm mr-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-red-brand font-medium",
                        children: toast.title
                    }),
                    (toast === null || toast === void 0 ? void 0 : toast.coupon_code) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Cod:",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                className: "font-medium",
                                children: toast.coupon_code
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: toast.description
                    }),
                    (toast === null || toast === void 0 ? void 0 : toast.url_link) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-[#0F62FE] underline",
                            href: toast.url_link,
                            children: toast.url_text || "Detalii"
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var components_PromoToasts = ((0,es/* connect */.$j)(function(state) {
    return {
        user: state.user,
        userDismissedNewsletter: state.app.userDismissedNewsletter
    };
}, {
    setPromoToastVisible: actions/* setPromoToastVisible */.CA
})(PromoToasts));


/***/ }),

/***/ 1144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Catalog_CompareWidget; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./store/catalog/actions.js
var actions = __webpack_require__(35493);
// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
// EXTERNAL MODULE: ./components/Icons/ArrowDown.js
var ArrowDown = __webpack_require__(26206);
// EXTERNAL MODULE: ./components/Icons/Close.js
var Close = __webpack_require__(30002);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/Icons/Compare.js



var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var Compare = function(param) {
    var _width = param.width, width = _width === void 0 ? "20px" : _width, _height = param.height, height = _height === void 0 ? "20px" : _height;
    return websiteName === "bricostore" ? // Material Design "compare_arrows" (24x24, Apache-2.0). Color via currentColor (was hardcoded fill="white").
    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "fill-current",
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M9.01 14H2v2h7.01v3L13 15l-3.99-4v3Zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4Z"
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "fill-current",
        width: width,
        height: height,
        viewBox: "0 0 31 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M30.9548 15.5223C30.9578 15.5435 30.9607 15.5647 30.9647 15.5856C30.9686 15.6065 30.9742 15.6274 30.9798 15.6482L30.9798 15.6482C30.9899 15.6855 30.9999 15.7227 30.9999 15.7601L31 15.7603C31 19.5521 27.9121 22.6362 24.1166 22.6362C20.3204 22.6362 17.2325 19.5521 17.2325 15.7603L17.2326 15.7601C17.2326 15.7227 17.2426 15.6855 17.2527 15.6482L17.2527 15.6482L17.2527 15.6482L17.2527 15.6481L17.2527 15.6481L17.2528 15.648C17.2584 15.6272 17.264 15.6065 17.2678 15.5856C17.2718 15.5647 17.2747 15.5435 17.2777 15.5222C17.2844 15.4741 17.291 15.4262 17.3094 15.3829L17.3095 15.3825L22.5892 2.95773L17.9361 3.40172C17.59 4.41909 16.6349 5.15815 15.5 5.15815C14.5396 5.15815 13.7098 4.62609 13.2647 3.84783L8.30225 4.32133L13.688 16.7388L13.6884 16.7404C13.6885 16.7412 13.6885 16.7421 13.6889 16.7429C13.7023 16.7741 13.7074 16.8086 13.7124 16.8432L13.7124 16.8432C13.7154 16.8637 13.7184 16.8842 13.7232 16.9041C13.7277 16.9234 13.733 16.9427 13.7382 16.9619C13.7525 17.0146 13.7667 17.067 13.7668 17.12L13.767 17.1208L13.7672 17.1214C13.7673 17.1219 13.7675 17.1224 13.7675 17.1229C13.7675 20.9147 10.6796 24 6.88342 24C3.08789 24 0 20.9147 0 17.1229C0 17.1224 0.000156482 17.1219 0.000313544 17.1214L0.000315299 17.1214C0.000472978 17.121 0.000630656 17.1205 0.000630592 17.12C0.000746137 17.067 0.0149952 17.0146 0.0293028 16.9619C0.0345242 16.9427 0.0397534 16.9234 0.0443064 16.9041C0.0490546 16.8842 0.0520593 16.8637 0.0550585 16.8432C0.0601265 16.8086 0.0651786 16.7741 0.0786005 16.7429C0.0788765 16.7422 0.0789553 16.7415 0.0790342 16.7408C0.079113 16.7402 0.0791918 16.7395 0.0794677 16.7388L5.99414 3.10043C6.00455 3.07646 6.02025 3.05715 6.03599 3.0378C6.04707 3.02417 6.05817 3.01052 6.06746 2.9952C6.07523 2.98229 6.08265 2.9693 6.09002 2.95638L6.09005 2.95633C6.11199 2.9179 6.1336 2.88005 6.16332 2.8466C6.16804 2.84129 6.17251 2.83594 6.17696 2.83062L6.17696 2.83062C6.18464 2.82144 6.19225 2.81234 6.20093 2.80363C6.22488 2.77966 6.25245 2.76193 6.28027 2.74404L6.28027 2.74403C6.2943 2.73501 6.30839 2.72595 6.3221 2.71602L6.35025 2.69509C6.3867 2.66775 6.42248 2.64092 6.46456 2.62047C6.47076 2.61745 6.47582 2.61318 6.48087 2.60893C6.48634 2.6043 6.49181 2.59969 6.4987 2.5967C6.50121 2.59563 6.50381 2.59534 6.5064 2.59505C6.50893 2.59477 6.51146 2.59449 6.51391 2.59348C6.54467 2.58076 6.57725 2.57538 6.61003 2.56997C6.62817 2.56698 6.64636 2.56397 6.66433 2.55971C6.68222 2.55543 6.69905 2.54893 6.71585 2.54245L6.71586 2.54245L6.71586 2.54245L6.71586 2.54245L6.71587 2.54244C6.74008 2.53311 6.76421 2.52379 6.79134 2.52115L13.0105 1.92777C13.3016 0.822174 14.3021 0 15.5 0C16.5246 0 17.4039 0.603211 17.8213 1.46836L24.0245 0.876482C24.0324 0.875742 24.0398 0.877214 24.0473 0.878688C24.0541 0.880036 24.0609 0.881386 24.0681 0.881047C24.1379 0.877352 24.2037 0.889201 24.2711 0.901347L24.2843 0.903715C24.2999 0.906526 24.3156 0.908763 24.3312 0.91099C24.3676 0.916181 24.4036 0.921316 24.4381 0.933545C24.446 0.936386 24.4541 0.938281 24.4622 0.940171C24.472 0.94247 24.4818 0.944761 24.4913 0.948735C24.4918 0.948959 24.4924 0.949024 24.493 0.949089C24.4937 0.949161 24.4944 0.949233 24.495 0.949522C24.5055 0.953966 24.5138 0.960844 24.5222 0.967729C24.5295 0.97377 24.5369 0.979818 24.5457 0.984232C24.5616 0.992222 24.5761 1.00251 24.5907 1.0128C24.6 1.01934 24.6092 1.02589 24.6188 1.03185C24.6318 1.03991 24.6449 1.04754 24.658 1.05512L24.658 1.05513L24.658 1.05514C24.6919 1.07486 24.7254 1.09432 24.7551 1.12063C24.7615 1.12625 24.768 1.13132 24.7746 1.13637L24.7746 1.13638L24.7746 1.1364C24.784 1.14358 24.7933 1.15072 24.8018 1.15936C24.8241 1.18174 24.8402 1.20792 24.8564 1.23425C24.8657 1.2494 24.8751 1.2646 24.8856 1.27915L24.9048 1.30489C24.9333 1.34286 24.9612 1.38004 24.9824 1.42389C24.9856 1.43072 24.9903 1.43635 24.9949 1.44197C25 1.44815 25.0051 1.45432 25.0084 1.46206L30.9231 15.3825L30.9231 15.3829C30.9415 15.4262 30.9482 15.4741 30.9548 15.5223ZM20 15H28L24.0002 4L20 15ZM6.99982 5L11 16H3L6.99982 5ZM2 18C2.46571 20.2772 4.52903 22 6.99967 22C9.47089 22 11.5343 20.2772 12 18H2ZM14.5 2C14.2241 2 14 1.77539 14 1.5C14 1.22461 14.2241 1 14.5 1C14.7759 1 15 1.22461 15 1.5C15 1.77539 14.7759 2 14.5 2ZM19 17C19.4657 19.2777 21.5291 21 24.0003 21C26.471 21 28.5343 19.2777 29 17H19Z",
            fill: "white"
        })
    });
};
/* harmony default export */ var Icons_Compare = (Compare);

// EXTERNAL MODULE: ./lib/clientStore.js
var clientStore = __webpack_require__(66208);
;// CONCATENATED MODULE: ./containers/Catalog/CompareWidget.js












var CompareWidget_ref = (0,config["default"])(), settings = CompareWidget_ref.publicRuntimeConfig.settings;
var isBricoStore = settings.websiteName === "bricostore";
// Brico: the compare bar is red (was black) with a Macan Stencil first letter on "Compara".
// The trigger <div>s are flex containers, so wrap the label in an inline-block block-container
// for ::first-letter to fire (see .bd-claim in bricostore-typography.css).
var compareBg = isBricoStore ? "bg-red-brand" : "bg-black";
// Brico: round the modal's left corners too (to match the right)
var modalTopRadius = isBricoStore ? "rounded-t-lg" : "rounded-tr-lg";
var CompareLabel = function() {
    return isBricoStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "bd-claim inline-block",
        children: "Compara"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "Compara"
    });
};
var CompareWidget = function(param) {
    var compareList = param.compareList, removeFromCompare1 = param.removeFromCompare, toggleCompare1 = param.toggleCompare, compareVisible = param.compareVisible, isPromoToastVisible = param.isPromoToastVisible, userDismissedNewsletter = param.userDismissedNewsletter, // PDP mobile: lift the widget above the sticky add-to-cart bar so they don't overlap
    showsStickyCta = param.showsStickyCta;
    if (!(compareList === null || compareList === void 0 ? void 0 : compareList.length)) {
        return null;
    }
    // TDOD add a way to update redux state for the user to dismiss the newsletter popup
    var isCookieConsentPopupVisible = Boolean(!clientStore/* cookieClientStore.get */.u.get("CookieConsent"));
    var isNewsletterPopupVisible = !userDismissedNewsletter;
    var classes = classnames_default()("Compare fixed right-15px rounded-tr-lg rounded-bl-lg z-10 bottom-6", {
        "Compare-is-expanded": compareVisible,
        // lift above the mobile sticky add-to-cart bar (~67px); no lift on desktop (bar is md:hidden)
        "-translate-y-[72px] md:translate-y-0": showsStickyCta,
        // only cookies are visible
        "bottom-[10px] xl:bottom-[200px]": isCookieConsentPopupVisible && !isNewsletterPopupVisible && !isPromoToastVisible,
        // cookies and newsletter OR toast are visible
        "bottom-[110px] sm:bottom-[115px] xl:bottom-[310px]": isCookieConsentPopupVisible && (!isNewsletterPopupVisible && isPromoToastVisible || isNewsletterPopupVisible && !isPromoToastVisible),
        // all are visible
        "bottom-[110px] sm:bottom-[210px] xl:bottom-[400px]": isCookieConsentPopupVisible && isNewsletterPopupVisible && isPromoToastVisible,
        // newsletter AND toast are visible
        "bottom-[120px] sm:bottom-[210px]": !isCookieConsentPopupVisible && isNewsletterPopupVisible && isPromoToastVisible,
        // nesletter OR toast is visible
        "bottom-32 sm:bottom-28": !isCookieConsentPopupVisible && (isNewsletterPopupVisible && !isPromoToastVisible || !isNewsletterPopupVisible && isPromoToastVisible)
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes,
        id: "compare-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hidden md:flex ".concat(compareBg, " ").concat(modalTopRadius, " text-white cursor-pointer p-4 text-lg leading-3 items-center justify-between"),
                onClick: function() {
                    return toggleCompare1();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareLabel, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                        customClassName: "fill-current inline-block transition-all duration-[400ms] ease-in-out  ".concat(compareVisible ? "rotate-0" : "rotate-180")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "\n            rounded-full text-white float-right cursor-pointer items-center justify-center w-[64px] h-[64px]\n            ".concat(compareVisible ? "hidden" : "flex", " md:hidden relative\n            ").concat(compareList.length > 1 ? compareBg : "bg-gray-1000", "\n          "),
                onClick: function() {
                    return toggleCompare1();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "absolute top-0 left-0 bg-red-brand text-white text-xs text-center leading-[16px] w-[19px] rounded-[4px]",
                        children: compareList.length
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Compare, {
                        width: "31px",
                        height: "24px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "Compare-content ".concat(modalTopRadius, " md:rounded-none bg-white border ").concat(compareVisible ? "block" : "hidden"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex md:hidden ".concat(compareBg, " ").concat(modalTopRadius, " text-white cursor-pointer\n              p-4 text-lg leading-3 items-center justify-between"),
                        onClick: function() {
                            return toggleCompare1();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareLabel, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "List border-[#C7C7C7]",
                        children: compareList.map(function(product) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                className: "flex items-center justify-between px-3 py-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,helpers/* resizeImage */.tg)(product.thumbnail, "56x56"),
                                        alt: product.name,
                                        width: "47",
                                        height: "47",
                                        className: "Compare-image box-border flex-none pr-[7px]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: "".concat(settings.baseUrl, "/").concat(product.url_key, "/cpd/").concat(product.sku, "/"),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "Compare-name truncate-3-lines text-black text-[10px] mr-[17px]",
                                            children: product.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "Compare-remove cursor-pointer text-center text-gray-light",
                                        onClick: function() {
                                            return removeFromCompare1(product.sku);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                            width: "14px",
                                            height: "14px"
                                        })
                                    })
                                ]
                            }, product.sku);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "p-4 pb-[22px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            href: compareList.length === 1 ? "" : "/compara/",
                            title: "Compara produse",
                            variant: "primary",
                            display: "block",
                            disabled: compareList.length === 1
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Catalog_CompareWidget = ((0,es/* connect */.$j)(function(state) {
    return {
        compareList: state.catalog.compare,
        compareVisible: state.catalog.compareVisible,
        isPromoToastVisible: state.app.isPromoToastVisible,
        userDismissedNewsletter: state.app.userDismissedNewsletter
    };
}, {
    removeFromCompare: actions/* removeFromCompare */.q7,
    toggleCompare: actions/* toggleCompare */.pf
})(CompareWidget));


/***/ }),

/***/ 89229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35035);
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__);

// JSON-LD blocks are injected with dangerouslySetInnerHTML, so a "<" coming
// from product data (a "</script>" inside a product name or description) would
// close the script element early and make the whole block unparsable for
// crawlers, besides letting the markup run in the browser. These characters
// are only ever part of JSON string values, where the escaped form is
// equivalent, so escaping them keeps the JSON valid and the page safe.
var HTML_UNSAFE_ESCAPES = {
    "<": "\\u003c",
    ">": "\\u003e",
    "&": "\\u0026"
};
var serializeSchema = function(schema) {
    return fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default()(schema).replace(/[<>&]/g, function(character) {
        return HTML_UNSAFE_ESCAPES[character];
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (serializeSchema);


/***/ }),

/***/ 6100:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var transformV2Banners = function(banners) {
    var basePath = "/media";
    var getImageObject = function(filePath, link) {
        return {
            link: link || "/",
            file: basePath + filePath
        };
    };
    var result = {
        id: banners.id || "",
        name: banners.name || "",
        position: banners.position || "",
        images: [],
        images_mobile: [],
        images_tablet: []
    };
    banners.images.forEach(function(item) {
        if (item.file) {
            result.images.push(getImageObject(item.file, item.url));
        }
        if (item.file_mobile) {
            result.images_mobile.push(getImageObject(item.file_mobile, item.url));
        }
        if (item.file_tablet) {
            result.images_tablet.push(getImageObject(item.file_tablet, item.url));
        }
    });
    return result;
};
/* harmony default export */ __webpack_exports__["Z"] = (transformV2Banners);


/***/ }),

/***/ 46115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-react.mjs + 3 modules
var swiper_react = __webpack_require__(2261);
// EXTERNAL MODULE: ./node_modules/swiper/modules/index.mjs + 27 modules
var modules = __webpack_require__(66832);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.css
var swiper = __webpack_require__(25194);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination.css
var pagination = __webpack_require__(18700);
// EXTERNAL MODULE: ./components/Icons/CarouselNavArrow.js
var CarouselNavArrow = __webpack_require__(57153);
;// CONCATENATED MODULE: ./components/HomepageSlider.js








var ref = (0,config["default"])(), settings = ref.publicRuntimeConfig.settings;
var HomepageSlider = function(param) {
    var items = param.items, _autoplay = param.autoplay, autoplay = _autoplay === void 0 ? false : _autoplay;
    var ref2 = (0,react.useState)(null), prevEl = ref2[0], setPrevEl = ref2[1];
    var ref1 = (0,react.useState)(null), nextEl = ref1[0], setNextEl = ref1[1];
    // Brico: the banner sits flush under the header, so keep its top square and
    // round only the bottom edge. Using `rounded-b-2xl` (an edge class) instead
    // of the diagonal `rounded-bl-2xl` avoids the centralized brico rounding CSS,
    // which would otherwise round the top corners too. Altex/MG keep the diagonal.
    var sliderRadius = settings.websiteName === "bricostore" ? "lg:rounded-b-2xl" : "lg:rounded-bl-2xl";
    // TODO this function should be moved to "@lib/GTMHelper"
    var trackBannerView = function(index) {
        var currentBanner = items[index];
        window.dataLayer.push({
            ecommerce: null
        }); // Clear the previous ecommerce object.
        window.dataLayer.push({
            event: "view_promotion",
            ecommerce: {
                promotion_name: "".concat(settings.websiteName.toUpperCase(), " - HOMEPAGE"),
                creative_name: currentBanner === null || currentBanner === void 0 ? void 0 : currentBanner.link,
                creative_slot: index
            }
        });
    };
    // TODO this function should be moved to "@lib/GTMHelper"
    var trackBannerClick = function(banner, index) {
        var ref3;
        window.dataLayer.push({
            ecommerce: null
        }); // Clear the previous ecommerce object.
        var creativeName = ((ref3 = banner.link) === null || ref3 === void 0 ? void 0 : ref3.startsWith("http")) ? new URL(banner.link).pathname : banner.link;
        window.dataLayer.push({
            event: "select_promotion",
            ecommerce: {
                promotion_name: "".concat(settings.websiteName.toUpperCase(), " - HOMEPAGE"),
                creative_name: creativeName,
                creative_slot: index
            }
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container px-0 lg:px-15px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "md:mb-4",
            children: items && items.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        className: "".concat(sliderRadius, " bg-red-brand"),
                        slidesPerView: 1,
                        spaceBetween: 0,
                        onSlideChange: function(props) {
                            trackBannerView(props.realIndex);
                        },
                        loop: true,
                        pagination: {
                            clickable: true
                        },
                        autoHeight: true,
                        autoplay: autoplay ? {
                            delay: 3500,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true
                        } : false,
                        navigation: {
                            nextEl: nextEl,
                            prevEl: prevEl
                        },
                        modules: [
                            modules/* Autoplay */.pt,
                            modules/* Pagination */.tl,
                            modules/* Navigation */.W_
                        ],
                        children: items.map(function(item, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: item.link,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    onClick: function() {
                                        return trackBannerClick(item, index);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(settings.cdn).concat(item.file),
                                        alt: "",
                                        className: "mx-auto"
                                    })
                                })
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden md:flex absolute top-0 left-0 ml-8 h-full items-center ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-7 h-7 lg:w-10 lg:h-10 bg-white opacity-90 lg:opacity-60 rounded-full cursor-pointer z-10",
                            ref: function(node) {
                                return setPrevEl(node);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselNavArrow/* default */.Z, {
                                direction: "left"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden md:flex absolute top-0 right-0 mr-8 h-full items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-7 h-7 lg:w-10 lg:h-10 bg-white opacity-90 lg:opacity-60 rounded-full cursor-pointer z-10",
                            ref: function(node) {
                                return setNextEl(node);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselNavArrow/* default */.Z, {
                                direction: "right"
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "".concat(settings.websiteStatics, "/images/empty-home-banner.jpg"),
                alt: ""
            })
        })
    }));
};
/* harmony default export */ var components_HomepageSlider = (HomepageSlider);

// EXTERNAL MODULE: ./lib/structuredData.js
var structuredData = __webpack_require__(89229);
;// CONCATENATED MODULE: ./components/OrganizationSchema.js




var OrganizationSchema_ref = (0,config["default"])(), _publicRuntimeConfig = OrganizationSchema_ref.publicRuntimeConfig, _settings = _publicRuntimeConfig.settings, baseUrl = _settings.baseUrl, websiteStatics = _settings.websiteStatics;
var OrganizationSchema = function() {
    var schema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        url: baseUrl,
        logo: "".concat(websiteStatics, "/images/logo.png")
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: (0,structuredData/* default */.Z)(schema)
        }
    }));
};
/* harmony default export */ var components_OrganizationSchema = (OrganizationSchema);

// EXTERNAL MODULE: ./components/Tabs.js
var Tabs = __webpack_require__(30672);
// EXTERNAL MODULE: ./components/ExpandableProductList.js + 1 modules
var ExpandableProductList = __webpack_require__(4761);
// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
// EXTERNAL MODULE: ./store/tracker/actions.js + 1 modules
var actions = __webpack_require__(48712);
// EXTERNAL MODULE: ./store/pages/actions.js + 1 modules
var pages_actions = __webpack_require__(94308);
// EXTERNAL MODULE: ./store/app/actions.js
var app_actions = __webpack_require__(27173);
// EXTERNAL MODULE: ./containers/Catalog/CompareWidget.js + 1 modules
var CompareWidget = __webpack_require__(1144);
// EXTERNAL MODULE: ./components/PromoToasts/index.js + 1 modules
var PromoToasts = __webpack_require__(30866);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation.css
var navigation = __webpack_require__(94375);
;// CONCATENATED MODULE: ./components/ShopInShopBanners.js









var ShopInShopBanners_ref = (0,config["default"])(), ShopInShopBanners_publicRuntimeConfig = ShopInShopBanners_ref.publicRuntimeConfig, ShopInShopBanners_settings = ShopInShopBanners_publicRuntimeConfig.settings, cdn = ShopInShopBanners_settings.cdn, websiteName = ShopInShopBanners_settings.websiteName;
// Brico: shop-in-shop tiles get rounded corners to match the brand's rounded
// card motif. These tiles carry no `rounded-*` class, so the centralized brico
// rounding CSS never reaches them — apply it here. Altex/MG keep square tiles.
var tileRadius = websiteName === "bricostore" ? "rounded-[8px]" : "";
var PreviousButton = function(param) {
    var setPrevEl = param.setPrevEl, isBeginning = param.isBeginning;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        ref: function(node) {
            return setPrevEl(node);
        },
        className: "w-8 h-8 md:w-10 md:h-10 rounded-full bg-gray-1300 ".concat(isBeginning ? "opacity-50 cursor-default" : "opacity-90 cursor-pointer"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselNavArrow/* default */.Z, {})
    });
};
var NextButton = function(param) {
    var setNextEl = param.setNextEl, isEnd = param.isEnd;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        ref: function(node) {
            return setNextEl(node);
        },
        className: "w-8 h-8 md:w-10 md:h-10 rounded-full bg-gray-1300 ".concat(isEnd ? "opacity-50 cursor-default" : "opacity-90 cursor-pointer"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselNavArrow/* default */.Z, {
            direction: "right"
        })
    });
};
var ShopInShopBanners = function(param1) {
    var banners = param1.banners;
    var ref4 = (0,react.useState)(true), isBeginning1 = ref4[0], setIsBeginning = ref4[1];
    var ref1 = (0,react.useState)(false), isEnd1 = ref1[0], setIsEnd = ref1[1];
    // Use state (not refs) for the nav elements: setting the node triggers a
    // re-render so Swiper re-initializes navigation with the real DOM button.
    // With refs, `.current` is still null when Swiper first inits (the buttons
    // mount after the Swiper) and the nav never binds — buttons do nothing.
    var ref2 = (0,react.useState)(null), prevEl = ref2[0], setPrevEl = ref2[1];
    var ref3 = (0,react.useState)(null), nextEl = ref3[0], setNextEl = ref3[1];
    var isSingleSlide = Boolean(banners.length === 1);
    (0,react.useEffect)(function() {
        banners.map(function(banner) {
            window.dataLayer.push({
                ecommerce: null
            }); // Clear the previous ecommerce object.
            window.dataLayer.push({
                event: "view_promotion",
                ecommerce: {
                    promotion_name: "Homepage Shop-in-Shop banners",
                    creative_name: banner.url,
                    creative_slot: banner.index
                }
            });
        });
    }, [
        banners
    ]);
    var trackBannerClick = function(banner) {
        window.dataLayer.push({
            ecommerce: null
        }); // Clear the previous ecommerce object.
        window.dataLayer.push({
            event: "select_promotion",
            ecommerce: {
                promotion_name: "Homepage Shop-in-Shop banners",
                creative_name: banner.url,
                creative_slot: banner.index
            }
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                className: "sm:hidden",
                slidesPerView: "auto",
                slidesPerGroup: 2,
                spaceBetween: 10,
                modules: [
                    modules/* Navigation */.W_,
                    modules/* FreeMode */.Rv
                ],
                onSlideChange: function(param) {
                    var isBeginning = param.isBeginning, isEnd = param.isEnd;
                    setIsBeginning(isBeginning);
                    setIsEnd(isEnd);
                },
                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl
                },
                children: banners.map(function(banner) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        className: "max-w-fit",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: banner.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                title: "",
                                onClick: function() {
                                    return trackBannerClick(banner);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(cdn).concat(banner.file_mobile),
                                    alt: "",
                                    className: "aspect-square w-[150px] max-w-[150px] ".concat(tileRadius)
                                })
                            })
                        })
                    }, banner.index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                className: "hidden sm:block md:hidden",
                slidesPerView: "auto",
                slidesPerGroup: 2,
                spaceBetween: 10,
                modules: [
                    modules/* Navigation */.W_,
                    modules/* FreeMode */.Rv
                ],
                onSlideChange: function(param) {
                    var isBeginning = param.isBeginning, isEnd = param.isEnd;
                    setIsBeginning(isBeginning);
                    setIsEnd(isEnd);
                },
                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl
                },
                children: banners.map(function(banner) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        className: "max-w-fit",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: banner.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                title: "",
                                onClick: function() {
                                    return trackBannerClick(banner);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(cdn).concat(banner.file_tablet),
                                    alt: "",
                                    className: "aspect-square w-[180px] max-w-[180px] ".concat(tileRadius)
                                })
                            })
                        })
                    }, banner.index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                className: "hidden md:block",
                slidesPerView: "auto",
                slidesPerGroup: 2,
                spaceBetween: 10,
                modules: [
                    modules/* Navigation */.W_,
                    modules/* FreeMode */.Rv
                ],
                onSlideChange: function(param) {
                    var isBeginning = param.isBeginning, isEnd = param.isEnd;
                    setIsBeginning(isBeginning);
                    setIsEnd(isEnd);
                },
                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl
                },
                children: banners.map(function(banner) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        className: "max-w-fit",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: banner.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                title: "",
                                onClick: function() {
                                    return trackBannerClick(banner);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(cdn).concat(banner.file),
                                    alt: "",
                                    className: "aspect-square w-[232px] max-w-[232px] ".concat(tileRadius)
                                })
                            })
                        })
                    }, banner.index);
                })
            }),
            !isSingleSlide && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute left-[10px] z-10 top-[40%]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviousButton, {
                            setPrevEl: setPrevEl,
                            isBeginning: isBeginning1
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute right-[10px] z-10 top-[40%]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextButton, {
                            setNextEl: setNextEl,
                            isEnd: isEnd1
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_ShopInShopBanners = (ShopInShopBanners);

// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
// EXTERNAL MODULE: ./components/Footprints/FootprintsWebAdsBanner.js
var FootprintsWebAdsBanner = __webpack_require__(42009);
// EXTERNAL MODULE: ./lib/transformV2Banners.js
var transformV2Banners = __webpack_require__(6100);
;// CONCATENATED MODULE: ./components/Footprints/FootprintsHomepageSlider.js



var FootprintsHomepageSlider_ref = (0,config["default"])(), FootprintsHomepageSlider_publicRuntimeConfig = FootprintsHomepageSlider_ref.publicRuntimeConfig, homepageSliderDataSourceId = FootprintsHomepageSlider_publicRuntimeConfig.footprints.homepageSliderDataSourceId;
var FOOTPRINTS_HOMEPAGE_SLIDER_ID = "FootprintsHomepageSlider";
var SLOT_CLASS_NAMES = [
    "ffrWebAdvertising1240x360webAdsSlider",
    "ffrWebAdvertising360x240webAdsSlider", 
];
var FootprintsHomepageSlider = function(param) {
    var onSlidesChange = param.onSlidesChange;
    var ref1 = (0,react.useState)(false), hasSlides = ref1[0], setHasSlides = ref1[1];
    var wrapperRef = (0,react.useRef)(null);
    var onSlidesChangeRef = (0,react.useRef)(onSlidesChange);
    onSlidesChangeRef.current = onSlidesChange;
    var loadScript = (0,react.useCallback)(function() {
        var script = document.createElement("script");
        script.src = "https://at-ffr-ai.altex.ro/web-advertising-slider/".concat(homepageSliderDataSourceId, "/web_advertising_slider/script.js?hostUrl=").concat(encodeURIComponent(window.location.href));
        script.id = FOOTPRINTS_HOMEPAGE_SLIDER_ID;
        script.async = true;
        document.head.appendChild(script);
    }, []);
    (0,react.useEffect)(function() {
        loadScript();
        return function() {
            // Cleanup script on component unmount
            var script = document.getElementById(FOOTPRINTS_HOMEPAGE_SLIDER_ID);
            if (script) {
                document.head.removeChild(script);
            }
        };
    }, []);
    // Track whether the script actually filled the slots, instead of keying off
    // its `onload`: the script loads even when the ads API returns no content,
    // and it fills the slots later, once that request answers. Reporting this up
    // lets the page keep the CMS banners on screen while the slots are empty.
    (0,react.useEffect)(function() {
        var wrapper = wrapperRef.current;
        if (!wrapper) {
            return undefined;
        }
        var syncSlides = function() {
            var ref2;
            var isFilled = SLOT_CLASS_NAMES.some(function(className) {
                var ref3;
                return (ref3 = wrapper.querySelector(".".concat(className))) === null || ref3 === void 0 ? void 0 : ref3.childElementCount;
            });
            setHasSlides(isFilled);
            (ref2 = onSlidesChangeRef.current) === null || ref2 === void 0 ? void 0 : ref2.call(onSlidesChangeRef, isFilled);
        };
        var observer = new MutationObserver(syncSlides);
        observer.observe(wrapper, {
            childList: true,
            subtree: true
        });
        syncSlides();
        return function() {
            var ref4;
            observer.disconnect();
            (ref4 = onSlidesChangeRef.current) === null || ref4 === void 0 ? void 0 : ref4.call(onSlidesChangeRef, false);
        };
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: wrapperRef,
        className: "".concat(hasSlides ? "flex justify-center items-center py-[20px]" : "invisible"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ffrWebAdvertising1240x360webAdsSlider"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ffrWebAdvertising360x240webAdsSlider"
            })
        ]
    }));
};
/* harmony default export */ var Footprints_FootprintsHomepageSlider = (FootprintsHomepageSlider);

// EXTERNAL MODULE: ./components/CredexUserPromoBanner/index.js + 2 modules
var CredexUserPromoBanner = __webpack_require__(87246);
;// CONCATENATED MODULE: ./pages/index.js
























function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var pages_ref = (0,config["default"])(), pages_publicRuntimeConfig = pages_ref.publicRuntimeConfig, pages_settings = pages_publicRuntimeConfig.settings, content = pages_publicRuntimeConfig.content;
// TODO Before live deploy we must set live banners ID
// TODO Before live deploy we must set live banners ID
// TODO Before live deploy we must set live banners ID
var BANNERS_IDS = {
    altex: {
        shopInShop: {
            prod: "adebe594-6419-440d-8110-ce6b1dc6d9ef",
            staging: "d49cc0b2-ed17-47ef-be80-2f3d53b7c1f4"
        },
        hero: {
            prod: 51,
            staging: 51
        }
    },
    mediagalaxy: {
        shopInShop: {
            prod: "6b7f2f4c-e99c-42a1-b361-542e8bbc12bb",
            staging: "d49cc0b2-ed17-47ef-be80-2f3d53b7c1f4"
        },
        hero: {
            prod: 52,
            staging: 52
        }
    },
    bricostore: {
        shopInShop: {
            prod: "a363e6b8-4bb6-4f03-bcb5-9ede21772d4b",
            staging: "a363e6b8-4bb6-4f03-bcb5-9ede21772d4b"
        },
        hero: {
            prod: "80d1e07a-9742-4653-bd05-b65659e10828",
            staging: "80d1e07a-9742-4653-bd05-b65659e10828"
        }
    }
};
var Home = function(param) {
    var pageRes = param.pageRes, promotions = param.promotions, shopInShopBanners = param.shopInShopBanners, heroBanners = param.heroBanners, trackProductClick1 = param.trackProductClick, layoutProps = param.layoutProps, featureFlags = param.featureFlags, customer = param.customer;
    var asyncPageInternalAnchors = {
        promoted: "oferte-zilnice",
        containers: "oferte",
        discounted: "promotii"
    };
    var alternateIndex = !!layoutProps && !!layoutProps.urlAsPath && layoutProps.urlAsPath.indexOf("/home/") === 0;
    // The footprints slider takes the hero slot only once it has actually
    // rendered an ad. Its content API can answer with no content at all, and its
    // campaigns are matched against the exact page URL, so the slot stays empty
    // on /home/ and on any URL carrying query params. Until slides show up, the
    // CMS banners stay on screen instead of leaving the hero blank.
    var ref1 = (0,react.useState)(false), /*#__PURE__*/ hasFootprintsSlides = ref1[0], setHasFootprintsSlides = ref1[1];
    var showFootprintsSlider = Boolean((featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.enableFootprints) && (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.enableHomepageFootprintsSlider));
    var showHeroBanners = Boolean(heroBanners) && !hasFootprintsSlides;
    var showFootprintsBanner = Boolean((featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.enableFootprints) && (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.enableFootprintsBanner));
    var handleProductClick = function(product, data) {
        // Track product click
        trackProductClick1(product, data);
    };
    var hasCredexUserPromo = (customer === null || customer === void 0 ? void 0 : customer.has_promo) === "CC12RATE";
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: !!pageRes && pageRes.title || content.websiteTitle
                    }),
                    alternateIndex ? /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "alternate",
                        href: pages_settings.baseUrl
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: pages_settings.baseUrl
                    }),
                    !!pageRes && !!pageRes.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: pageRes.description
                    }),
                    !!pageRes && !!pageRes.keywords && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: pageRes.keywords
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OrganizationSchema, {}),
            showFootprintsSlider && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footprints_FootprintsHomepageSlider, {
                onSlidesChange: setHasFootprintsSlides
            }),
            showHeroBanners && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    heroBanners.images_mobile.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sm:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HomepageSlider, {
                            items: heroBanners.images_mobile
                        }, "1")
                    }),
                    heroBanners.images_tablet.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden sm:block lg:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HomepageSlider, {
                            items: heroBanners.images_tablet,
                            autoplay: true
                        }, "2")
                    }),
                    heroBanners.images.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden lg:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HomepageSlider, {
                            items: heroBanners.images,
                            autoplay: true
                        }, "3")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    shopInShopBanners && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container pt-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ShopInShopBanners, {
                            banners: shopInShopBanners.map(function(banner, index) {
                                return _objectSpread({}, banner, {
                                    index: index + 1
                                });
                            })
                        })
                    }),
                    hasCredexUserPromo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container mt-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CredexUserPromoBanner/* default */.Z, {})
                    }),
                    promotions.top_offer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: asyncPageInternalAnchors.promoted,
                        className: "mt-3 container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h2",
                                display: "h2",
                                title: "Top Oferte",
                                classesProp: "lg:mb-4 mt-28px lg:mt-12 lg:-tracking-0.67 -tracking-0.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableProductList/* default */.Z, {
                                products: promotions.top_offer.map(function(product, index) {
                                    return _objectSpread({}, product, {
                                        index: index + 1,
                                        item_list_name: "top oferte"
                                    });
                                }),
                                desktopVisibleProducts: 10,
                                onProductClick: function(product) {
                                    return handleProductClick(product);
                                }
                            })
                        ]
                    }),
                    promotions.top_offer_tabs && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("mt-20 md:px-10 md:pt-12 md:pb-6 md:mb-16", {
                            "bg-gray-100": pages_settings.websiteName !== "bricostore",
                            "bg-gray-lighter": pages_settings.websiteName === "bricostore"
                        }),
                        id: asyncPageInternalAnchors.containers,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z, {
                            children: promotions.top_offer_tabs.map(function(container, index1) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Tabs/* Tab */.O, {
                                    selected: index1 === 0 && true,
                                    title: container.tab_name,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-6 mb-10 mx-4 lg:mx-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableProductList/* default */.Z, {
                                            products: container.products.map(function(product, index) {
                                                return _objectSpread({}, product, {
                                                    index: index + 1,
                                                    item_list_name: "oferta zilei"
                                                });
                                            }),
                                            desktopVisibleProducts: 5,
                                            onProductClick: function(product) {
                                                return handleProductClick(product);
                                            }
                                        })
                                    })
                                }, "".concat(container.tab_name, "-").concat(index1));
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: promotions.promotions && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: asyncPageInternalAnchors.discounted,
                            className: "mb-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    as: "h2",
                                    display: "h2",
                                    title: "Promotii",
                                    classesProp: "mt-28px lg:my-3 lg:-tracking-0.67 -tracking-0.5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableProductList/* default */.Z, {
                                    products: promotions.promotions.map(function(product, index) {
                                        return _objectSpread({}, product, {
                                            index: index + 1,
                                            item_list_name: "promotii"
                                        });
                                    }),
                                    desktopVisibleProducts: 10,
                                    onProductClick: function(product) {
                                        return handleProductClick(product);
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareWidget/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoToasts/* default */.Z, {
                type: "homepage"
            }),
            showFootprintsBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FootprintsWebAdsBanner/* default */.Z, {
                    desktopSize: "970x250",
                    mobileSize: "300x250"
                })
            })
        ]
    }));
};
var _tmp;
_tmp = (function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(ctx) {
        var ref9, ref2, ref3, ref4, reduxStore, pageProps, pageRes, pageBanners, pageRequests, ref5, pagePromotions, content1, rest, ref6, ref7, ref8, topOffersTabsWithProducts, shopInShopBanners, heroBanners;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    reduxStore = ctx.reduxStore;
                    pageProps = {
                        pageRes: null,
                        promotions: {},
                        shopInShopBanners: null,
                        heroBanners: null
                    };
                    _ctx.next = 5;
                    return reduxStore.dispatch((0,pages_actions/* getPage */.f)("home"));
                case 5:
                    pageRes = _ctx.sent;
                    _ctx.next = 8;
                    return reduxStore.dispatch((0,app_actions/* getCmsBlocks */.lD)([
                        "altex_catalog_product_services"
                    ]));
                case 8:
                    _ctx.next = 10;
                    return reduxStore.dispatch((0,app_actions/* apiCall */.k_)({
                        apiCall: api/* getBannersV2Api */.a5o,
                        formatResponse: function(response) {
                            return response.data;
                        }
                    }));
                case 10:
                    pageBanners = _ctx.sent;
                    pageRequests = [
                        // 7 as payload will fetch all promotions categories
                        reduxStore.dispatch((0,pages_actions/* getCatalogPromotions */.l)(7)), 
                    ];
                    // The feature flags decide whether the footprints slider is mounted, so the
                    // request has to settle before the page renders. Left floating, the server
                    // render raced it and the same URL came back with or without the flags in
                    // the store, with the page cache then freezing whichever variant won.
                    if (!reduxStore.getState().app.websiteAdminConfigs.featureFlagsWebsite) {
                        pageRequests.push(reduxStore.dispatch((0,app_actions/* getWebsiteAdminConfig */.z5)({
                            code: "featureFlagsWebsite"
                        })));
                    }
                    _ctx.t0 = _slicedToArray;
                    _ctx.next = 16;
                    return Promise.all(pageRequests);
                case 16:
                    _ctx.t1 = _ctx.sent;
                    ref5 = (0, _ctx.t0)(_ctx.t1, 1);
                    pagePromotions = ref5[0];
                    if (pageRes) {
                        content1 = pageRes.content, rest = _objectWithoutProperties(pageRes, [
                            "content"
                        ]);
                        pageProps.pageRes = rest;
                    }
                    if (pagePromotions === null || pagePromotions === void 0 ? void 0 : pagePromotions.data) {
                        ;
                        if (((ref6 = pagePromotions.data.top_offer) === null || ref6 === void 0 ? void 0 : ref6.length) > 0) {
                            pageProps.promotions.top_offer = pagePromotions.data.top_offer;
                        }
                        if (((ref7 = pagePromotions.data.promotions) === null || ref7 === void 0 ? void 0 : ref7.length) > 0) {
                            pageProps.promotions.promotions = pagePromotions.data.promotions;
                        }
                        topOffersTabsWithProducts = (ref8 = pagePromotions.data.top_offer_tabs) === null || ref8 === void 0 ? void 0 : ref8.filter(function(tab) {
                            var ref10;
                            return ((ref10 = tab.products) === null || ref10 === void 0 ? void 0 : ref10.length) > 0;
                        });
                        if ((topOffersTabsWithProducts === null || topOffersTabsWithProducts === void 0 ? void 0 : topOffersTabsWithProducts.length) > 0) {
                            pageProps.promotions.top_offer_tabs = topOffersTabsWithProducts;
                        }
                    }
                    shopInShopBanners = pageBanners === null || pageBanners === void 0 ? void 0 : (ref9 = pageBanners.items) === null || ref9 === void 0 ? void 0 : ref9.find(function(item) {
                        return item.id == BANNERS_IDS[pages_settings.websiteName].shopInShop[pages_settings.isProd && !pages_settings.isStaging ? "prod" : "staging"];
                    });
                    heroBanners = pageBanners === null || pageBanners === void 0 ? void 0 : (ref2 = pageBanners.items) === null || ref2 === void 0 ? void 0 : ref2.find(function(item) {
                        return item.id == BANNERS_IDS[pages_settings.websiteName].hero[pages_settings.isProd && !pages_settings.isStaging ? "prod" : "staging"];
                    });
                    if ((shopInShopBanners === null || shopInShopBanners === void 0 ? void 0 : (ref3 = shopInShopBanners.images) === null || ref3 === void 0 ? void 0 : ref3.length) > 0) {
                        pageProps.shopInShopBanners = shopInShopBanners.images;
                    }
                    if ((heroBanners === null || heroBanners === void 0 ? void 0 : (ref4 = heroBanners.images) === null || ref4 === void 0 ? void 0 : ref4.length) > 0) {
                        pageProps.heroBanners = (0,transformV2Banners/* default */.Z)(heroBanners);
                    }
                    return _ctx.abrupt("return", pageProps);
                case 26:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
})(), Home.getInitialProps = _tmp, _tmp;
Home.pageLayout = "default";
/* harmony default export */ var pages = ((0,es/* connect */.$j)(function(state) {
    return {
        cmsBlocks: state.app.cmsBlocks,
        customer: state.user.customer,
        featureFlags: state.app.websiteAdminConfigs.featureFlagsWebsite
    };
}, {
    trackProductClick: actions/* trackProductClick */.Cg,
    getPage: pages_actions/* getPage */.f
})(Home));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1423,9774,2888,179], function() { return __webpack_exec__(78581); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);